'use es6';

import UITextArea from '../input/UITextArea';
import UITextInput from '../input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultRenderers = {
  text: props => /*#__PURE__*/_jsx(UITextInput, Object.assign({}, props)),
  textarea: props => /*#__PURE__*/_jsx(UITextArea, Object.assign({}, props))
};